/**
 * Plan limit helpers.
 * Convention: limit < 0 (e.g. -1) = unlimited, 0 = none allowed, >0 = max count.
 */

export const isUnlimitedPlanLimit = (limit) => {
  const n = parseInt(limit, 10);
  return !Number.isNaN(n) && n < 0;
};

export const isAtPlanLimit = (limit, used) => {
  if (isUnlimitedPlanLimit(limit)) {
    return false;
  }
  const max = parseInt(limit, 10);
  const count = parseInt(used, 10) || 0;
  if (Number.isNaN(max)) {
    return false;
  }
  return count >= max;
};

export const PLAN_LIMIT_TYPES = {
  EVENTS: "events",
  SEATS: "seats",
  CALENDARS: "calendars",
};

export const PLAN_LIMIT_LABELS = {
  events: "events",
  seats: "seats",
  calendars: "calendars",
};
